export default "__VITE_ASSET__DxmUwbEo__"